import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { DomainCacheService } from './domain-cache.service';

@Injectable({
  providedIn: 'root'
})
export class StatusValidacaoService {
  private readonly baseUrl = 'status-validacao';

  constructor(
    private apiService: ApiService,
    private domainCache: DomainCacheService
  ) {}

  consultarCombo(): Observable<any[]> {
    const url = `${this.baseUrl}/combo`;
    return this.domainCache.getOrLoad(url, () =>
      this.apiService.get<any[]>(url, undefined, undefined, true)
    );
  }
}
